import { EventTypes, getPageSource, track } from '@mc/track-event'

export const trackModalClicked = ({ action }: { action: string }) =>
  track(EventTypes.MODAL_CLICKED, {
    action,
    modal_type: 'on-call-modal',
    location: 'on-call-explainer-modal',
    page_source: getPageSource(),
  })
